<section class="bids-panel">
    <!-- Header: title + search (design_handoff_profile_redesign §5) -->
    <vb-panel-header [title]="'My bidding'">
        <div panelActions>
            <vb-search-input
                [value]="searchQuery"
                placeholder="Search your bids…"
                ariaLabel="Search your bids"
                (valueChange)="onSearchChange($event)">
            </vb-search-input>
        </div>
    </vb-panel-header>

    <!-- Top pagination lockup — keeps today's summary + per-page 10/25/50 -->
    <vb-paginator-bar
        *ngIf="!isLoading && tableRows.length > 0"
        class="bids-panel__topbar"
        variant="top"
        label="bids"
        [dense]="isMobile"
        [current]="paginate.currentPage ?? 1"
        [total]="paginate.totalPages ?? 0"
        [totalItems]="paginate.totalItems ?? 0"
        [perPage]="pageSize"
        [perPageOptions]="pageSizeOptions"
        (pageChange)="setPage($event)"
        (perPageChange)="setPageSize($event)">
    </vb-paginator-bar>

    <!-- Ledger table (scroll wrapper + empty state live inside) -->
    <div class="bids-panel__table" *ngIf="!isLoading">
        <vb-bid-table
            [rows]="tableRows"
            (rowClick)="onRowNavigate($event)"
            (bidClick)="onBidClick($event)"
            (viewClick)="onRowNavigate($event)">
        </vb-bid-table>
    </div>

    <!-- Spinner -->
    <div *ngIf="isLoading" class="vb-spinner-box vb-spinner-box--panel">
        <vb-spinner size="xl" label="Loading bids"></vb-spinner>
    </div>

    <!-- Footer: status legend left, pager right -->
    <div class="bids-panel__footer" *ngIf="!isLoading && tableRows.length > 0">
        <vb-legend [items]="legendItems"></vb-legend>
        <vb-paginator
            [current]="paginate.currentPage ?? 1"
            [total]="paginate.totalPages ?? 0"
            [labels]="false"
            [dense]="isMobile"
            (pageChange)="setPage($event)">
        </vb-paginator>
    </div>
</section>

<!-- Bid confirmation (library dialog, same as the lot list / lot details). -->
<vb-bid-confirm-dialog
    [open]="confirmDialogOpen"
    [amount]="pendingBidAmount"
    [bpPct]="pendingBidBpPct"
    (confirmed)="onBidConfirmed($event)"
    (cancelled)="onBidCancelled()" />
